import(/* webpackMode: "eager" */ "/app/apps/portal-play/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/apps/portal-play/src/app/(seo)/_components/ArticleBody.tsx")